if(typeof campaign_cf7_controller == 'undefined'){
    var campaign_cf7_controller = {
        params: {},
        fields: [
            'utm_source',
            'utm_medium',
            'utm_campaign'
        ],
        get_params: function(){
            var url = new URL(window.location);
            var s = url.search;
            if(s.length == 0){
                return;
            }else{
                s = s.split('&');
                s[0] = s[0].replace('?', '');
                var params = {};
                for(var i = 0; i < s.length; i++){
                    var temp = s[i].split('=');
                    temp[0] = temp[0].toLowerCase();
                    params[temp[0]] = decodeURI(temp[1]);
                }
                campaign_cf7_controller.params = params;
            }
        },
        set_values: function(){
            campaign_cf7_controller.get_params();
            for(var i = 0; i < campaign_cf7_controller.fields.length; i++){
                var field = campaign_cf7_controller.fields[i];
                if(typeof campaign_cf7_controller.params[field] != 'undefined'){
                    var input = document.getElementById("input_"+field);
                    input.value = campaign_cf7_controller.params[field];
                }
            }
        }
    };
}
campaign_cf7_controller.set_values();